import { forwardRef } from "react";

import { Text } from "chameleon/lib/components";

import { formSubTitleClass } from "checkout-experience/components/forms/form-sub-title.css";

interface Props {
  title: string;
  value?: string;
}

export const FormSubTitle = forwardRef<HTMLDivElement, Props>(
  ({ title }: Props, ref) => (
    <div className={formSubTitleClass} ref={ref}>
      <Text styleVariant="heading3" tagElement="h3">
        {title}
      </Text>
    </div>
  )
);

FormSubTitle.displayName = "FormSubTitle";
